// ReaConne Store - Main JavaScript

(function() {
  'use strict';

  // Add smooth scroll behavior
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  }

  // Initialize cart functionality
  function initCart() {
    const cartIcon = document.querySelector('a[aria-label="カート"]');
    if (cartIcon) {
      cartIcon.addEventListener('click', () => {
        // Cart logic here
      });
    }
  }

  // Initialize search functionality
  function initSearch() {
    const searchIcon = document.querySelector('a[aria-label="検索"]');
    if (searchIcon) {
      searchIcon.addEventListener('click', () => {
        // Search logic here
      });
    }
  }

  // Initialize product cards
  function initProductCards() {
    const productCards = document.querySelectorAll('.product-card');
    productCards.forEach(card => {
      card.addEventListener('mouseenter', () => {
        card.style.transform = 'translateY(-4px)';
        card.style.boxShadow = '0 8px 20px rgba(0,0,0,0.1)';
      });
      card.addEventListener('mouseleave', () => {
        card.style.transform = 'translateY(0)';
        card.style.boxShadow = '0 6px 14px rgba(0,0,0,0.06)';
      });
    });
  }

  // Lazy load images
  function initLazyLoad() {
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
            }
            observer.unobserve(img);
          }
        });
      });

      document.querySelectorAll('img[data-src]').forEach(img => {
        imageObserver.observe(img);
      });
    }
  }

  // Track analytics events
  function initAnalytics() {
    // Add Google Analytics or other tracking here
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initSmoothScroll();
      initCart();
      initSearch();
      initProductCards();
      initLazyLoad();
      initAnalytics();
    });
  } else {
    initSmoothScroll();
    initCart();
    initSearch();
    initProductCards();
    initLazyLoad();
    initAnalytics();
  }

  // Expose for external use
  window.ReaConne = {
    initSmoothScroll,
    initCart,
    initSearch,
    initProductCards,
    initLazyLoad,
    initAnalytics
  };
})();
